import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalMessageService, GlobalMessageType } from "@spartacus/core";
import { StsAdminService } from "../sts-admin.service";


@Component({
    selector: 'app-sts-shipping-week',
    templateUrl: './sts-shipping-week.component.html',
    styleUrls: ['./sts-shipping-week.component.scss'],
    standalone: false
})
export class StsShippingWeekComponent implements OnInit, OnDestroy {
    dataSet = false;
    shipWeekDetails: any = [];
    shipWeekDataSubscription: any;
    manageShipWeekForm: FormGroup;
    disable: boolean;
    prevQuantityValue = null;
    timeOut: any;
    buttonDisable: boolean;
    constructor(
        private readonly stsAdminService: StsAdminService,
        private readonly cd: ChangeDetectorRef,
        private readonly fb: FormBuilder,
        private readonly globalMessage: GlobalMessageService,
    ) {
        this.manageShipWeekForm = this.fb.group({
            rows: this.fb.array([]),
        });
        this.disable = false;
        this.buttonDisable = false;
    }

    ngOnInit(): void {
        this.stsAdminService.getShippingWeekDetails();
        this.shipWeekDataSubscription = this.stsAdminService.shipWeekDetails$.subscribe((res) => {
            if (res !== null) {
                this.shipWeekDetails = res;
                this.patchValues();
                this.dataSet = true;
                this.cd.detectChanges();
            }
        })
    }

    patchValues(): void {
        let rows = this.manageShipWeekForm.get('rows') as FormArray;
        this.shipWeekDetails.shippingWeekMap.forEach((item) => {
            rows.push(
                this.fb.group({
                    shippingWeek: [item.key],
                    shippingWeekList: this.patchDetails(item.value.shippingWeekList),
                })
            );
        });
    }

    patchDetails(item_details: any[]): FormArray {
        let detailsFormArray: FormArray = new FormArray([]);
        item_details.forEach((item) => {
            let disableFlag = false;
            if (!item.available) {
                disableFlag = true;
            };

            detailsFormArray.push(
                this.fb.group({
                    available: [item.available],
                    quantity: [{
                        value: item.quantity,
                        disabled: disableFlag
                    },[Validators.maxLength(10),Validators.pattern('[0-9]*$')]],
                    productCode: [item.fluProducts.code],
                    sceduledDoses: [item.sceduledDoses],
                    shippingStartWeek: [item.shippingStartWeek],
                    preValue:[item.quantity],
                })
            )
        });
        return detailsFormArray;
    }


    checkUncheckBox(value, event, rowEvent) {
        const arr = < FormArray > this.manageShipWeekForm.get('rows');
        const innerArr = < FormArray > arr.controls[rowEvent].get('shippingWeekList');
        const qtyControl = innerArr.controls[event].get('quantity');
        const availableControl = innerArr.controls[event].get('available')
        if (availableControl.value) {
            qtyControl.enable();
        } else {
            qtyControl.disable();
        }
    }

    checkAll() {
        const outerArray = < FormArray > this.manageShipWeekForm.get('rows');
        for (let i = 0; i < outerArray.length; i++) {
            const innerArray = < FormArray > outerArray.controls[i].get('shippingWeekList');
            for (let j = 0; j < innerArray.length; j++) {
                if (innerArray.controls[j]) {
                    innerArray.controls[j].get('quantity').enable();
                    innerArray.controls[j].get('available').setValue(true)
                }
            }
        }

    }

    unCheckAll() {
        const outerArray = < FormArray > this.manageShipWeekForm.get('rows');

        for (let i = 0; i < outerArray.length; i++) {
            const innerArray = < FormArray > outerArray.controls[i].get('shippingWeekList');
            for (let j = 0; j < innerArray.length; j++) {
                if (innerArray.controls[j]) {
                    innerArray.controls[j].get('quantity').disable();
                    innerArray.controls[j].get('available').setValue(false)
                }
            }
        }
    }

    updateShipData() {
        this.buttonDisable = true;
        let stsValue = [];
        const outerArray = < FormArray > this.manageShipWeekForm.get('rows');

        for (let i = 0; i < outerArray.length; i++) {
            let testArr = [];
            const date = < FormArray > outerArray.controls[i].get('shippingWeek').value;

            const innerArray = < FormArray > outerArray.controls[i].get('shippingWeekList');
            for (let j = 0; j < innerArray.length; j++) {
                if (innerArray.controls[j]) {
                    let obj = {
                        "productCode": innerArray.controls[j].get('productCode').value,
                        "available": innerArray.controls[j].get('available').value,
                        "checked": "yes",
                        "quantity": innerArray.controls[j].get('quantity').value
                    }
                    testArr.push(obj);
                }
            }
            let productDEtails = {
                "fluProducts": testArr,
                "shippingStartWeek": date
            }
            stsValue.push(productDEtails)
        }
        const params = {
            "stsShippingWeekManageData": stsValue
        }
        this.stsAdminService.postShippingWeekData(params).subscribe((res) => {
            if (res.status === 'success') {
                this.buttonDisable = false;
                this.globalMessage.add('Successfully updated records', GlobalMessageType.MSG_TYPE_CONFIRMATION);
                window.location.reload();
            } else {
                this.buttonDisable = false;
                this.globalMessage.add('Something went wrong. Please try again', GlobalMessageType.MSG_TYPE_ERROR);
            }
        });
    }

    ngOnDestroy() {
        this.shipWeekDataSubscription?.unsubscribe();
    }

    quantityValidation(value, event, rowEvent, popover) {
        clearTimeout(this.timeOut);
        const arr = < FormArray > this.manageShipWeekForm.get('rows');
        const innerArr = < FormArray > arr.controls[rowEvent].get('shippingWeekList');
        const qtyControl = innerArr.controls[event].get('quantity');
        const scheduleDoseControl = innerArr.controls[event].get('sceduledDoses');
        const qtyPrevValueControl = innerArr.controls[event].get('preValue');
        const regex = /^\d*$/;
        const digitPattern = regex.test(qtyControl.value);
         if (!digitPattern) {
            qtyControl.setValue(qtyPrevValueControl.value, {
            emitEvent: false
        });
        }
        this.timeOut = setTimeout(()=> {      
        if (scheduleDoseControl.value > 0 && scheduleDoseControl.value > qtyControl.value) {
            if (popover.isOpen()) {
                popover.close();
            } else {
                popover.open();
            }
            qtyControl.setValue(qtyPrevValueControl.value, {
                emitEvent: false
            });
        } else {
        }
        }, 2000);      
    }
}